import { render } from "./RegistrateEC.vue?vue&type=template&id=1dce6943&scoped=true"
import script from "./RegistrateEC.vue?vue&type=script&lang=js"
export * from "./RegistrateEC.vue?vue&type=script&lang=js"

import "./RegistrateEC.vue?vue&type=style&index=0&id=1dce6943&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce6943"]])

export default __exports__